import { call, put, select, takeLatest } from 'redux-saga/effects'

import { selectAuthData } from '@/containers/Login/AuthSelectors'
import { pollResultsActions } from '@/containers/DevToolsNew/CommunicationBoard/PollResults/pollResultsSagas'
import { AVAILABLE_COMMUNICATION_BOARD_SECTIONS } from '@/containers/SubscriptionFormPageNew/Components/CommunicationBoard/constants'
import { callApi } from '@/shared/tools/apiSagaHelper'
import { showSnackbar, SNACKBAR_TYPES } from '@/shared/tools/notifications/notification'

import {
  fetchRequest,
  fetchSuccess,
  fetchFailure,
  saveRequest,
  saveSuccess,
  saveFailure,
} from './communicationBoardSlice'

import { selectCommunicationBoardContent } from './communicationBoardSelectors'

export const communicationBoardActions = {
  FETCH: 'DEVTOOLS_NEW/COMMUNICATION_BOARD/FETCH',
  SAVE: 'DEVTOOLS_NEW/COMMUNICATION_BOARD/SAVE',
}

function* fetchCommunicationBoardSaga({ enqueue, t, payload }) {
  yield put(fetchRequest())

  try {
    const { extraRoutes, country } = yield select(selectAuthData)
    const url = extraRoutes?.devTools?.communicationBoard?.show
    if (!url) {
      const message = t?.('communication_board.errors.missing_show_url') || 'Missing communication board url'
      yield put(fetchFailure(message))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    const section = payload?.section
    const result = yield call(callApi, {
      endpoint: url,
      method: 'GET',
      queryParams: { country, section },
      showErrorSnackbar: false,
    })

    yield put(fetchSuccess({ content: result?.content || '' }))
  } catch (error) {
    const message =
      error?.responseData?.error || error?.message || 'Error fetching communication board'
    yield put(fetchFailure(message))
  }
}

function* saveCommunicationBoardSaga({ enqueue, t, payload }) {
  yield put(saveRequest())

  try {
    const { extraRoutes, country } = yield select(selectAuthData)
    const url = extraRoutes?.devTools?.communicationBoard?.update
    if (!url) {
      const message = t?.('communication_board.errors.missing_update_url') || 'Missing communication board update url'
      yield put(saveFailure({ error: message }))
      if (enqueue) yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
      return
    }

    const section = payload?.section
    const content = yield select(selectCommunicationBoardContent)

    yield call(callApi, {
      endpoint: url,
      method: 'POST',
      payload: { country, section, content },
      showErrorSnackbar: false,
    })

    const message = t?.('communication_board.success') || 'Saved'
    yield put(saveSuccess({ message }))

    if (AVAILABLE_COMMUNICATION_BOARD_SECTIONS.includes(section)) {
      yield put({ type: pollResultsActions.FETCH })
    }

    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.SUCCESS, message })
    }
  } catch (error) {
    const message = error?.responseData?.error || error?.message || 'Unknown error'
    yield put(saveFailure({ error: message }))
    if (enqueue) {
      yield call(showSnackbar, enqueue, { type: SNACKBAR_TYPES.ERROR, message })
    }
  }
}

export default function* communicationBoardSagas() {
  yield takeLatest(communicationBoardActions.FETCH, fetchCommunicationBoardSaga)
  yield takeLatest(communicationBoardActions.SAVE, saveCommunicationBoardSaga)
}
